import _ from 'lodash';

export default {
  getAllowedDevices: (relayDevices, viewerDevices, reportDevices) => {
    // relayDevices - all devices under an account
    // viewerDevices - specific devices the logged in user (sub-user) has access to
    // reportDevices - devices used for the report
    const deviceEdges = (relayDevices && relayDevices.edges) || [];
    const deviceNodes = deviceEdges.map(edge => edge.node).filter(device => device.name !== 'Demo');
    const deviceArrays = [
      reportDevices,
      viewerDevices,
      deviceNodes
    ].filter(arr => arr && arr.length > 0);
    return _.intersectionBy(...deviceArrays, 'id');
  }
};



// WEBPACK FOOTER //
// ./src/services/allowedDevices/allowedDevices.js